<template>
  <v-list>
    <draggable v-model="draggableItems">
      <template v-for="item in orderedItems">
        <style-dialog-content-class
          :key="item.value"
          v-bind="{
            item,
            isActive: item.value === activeItem.value,
            layerType,
          }"
          @setActive="setActiveItem"
        />
      </template>
    </draggable>
  </v-list>
</template>
<script>
import StyleDialogContentClass from '@/components/StyleDialogContentClass';
import draggable from 'vuedraggable-multi';
export default {
  name: 'StyleDialogContentClasses',
  components: { StyleDialogContentClass, draggable },
  props: {
    activeItem: {
      type: Object,
      default: () => {
        return {};
      },
    },
    layerType: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  computed: {
    orderedItems() {
      return this.$_sortObjectsByAttribute(
        JSON.parse(JSON.stringify(this.items)).map((item, index) => {
          delete item.uniques;
          const order = item.order || item.order === 0 ? item.order : index;
          return { ...item, order };
        }),
        'order',
        false,
        true
      ).reverse();
    },
    draggableItems: {
      get() {
        return this.orderedItems;
      },
      set(nV) {
        this.$emit(
          'setClasses',
          nV.map((element, index) => {
            return { ...element, order: index };
          })
        );
      },
    },
  },
  methods: {
    setActiveItem(item) {
      this.$emit('setActiveItem', item.value);
    },
  },
};
</script>
